export const createIsNativeOfflineAudioContext = (nativeOfflineAudioContextConstructor) => {
    return (anyContext) => {
        if (nativeOfflineAudioContextConstructor === null) {
            throw new Error('The native OfflineAudioContext constructor is missing.');
        }
        return anyContext instanceof nativeOfflineAudioContextConstructor;
    };
};
//# sourceMappingURL=/build/es2018/factories/is-native-offline-audio-context.js.map